import { gameSettings } from "@kalaporssi/shared";
import { type FormEvent, useState } from "react";
import { Link, useNavigate } from "react-router";
import { Board } from "../components/Board";
import { readPlayerSession } from "../lib/api";

export function Home() {
  const nav = useNavigate();
  const [code, setCode] = useState("");
  const clean = code.trim().toUpperCase();
  const valid = clean.length === gameSettings.codeLength;
  const submit = (e: FormEvent) => {
    e.preventDefault();
    if (!valid) return;
    nav(readPlayerSession(clean) ? `/g/${clean}` : `/j/${clean}`);
  };
  return (
    <>
      <Board />
      <main className="stack">
        <h2>Liity peliin</h2>
        <p>
          Joka kuukausi arvotaan 12 Itämeren saalista. Jokainen valitsee salaa yhden, ja kaikki kalat myydään samassa
          pörssissä. Mitä useampi tuo samaa lajia markkinoille, sitä halvemmaksi kilo menee. Voitto syntyy muiden
          pelaajien ennakoinnista.
        </p>
        <form className="panel stack" onSubmit={submit}>
          <label htmlFor="code" className="h3label">
            Pelikoodi
          </label>
          <div className="row">
            <input
              id="code"
              type="text"
              className="codefield"
              inputMode="text"
              autoComplete="off"
              autoCapitalize="characters"
              maxLength={gameSettings.codeLength}
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="K7PX2M"
            />
            <button className="btn tag" type="submit" disabled={!valid}>
              Liity
            </button>
          </div>
          <p className="muted small">Koodi näkyy pelinjohtajan näytöllä. Voit myös skannata QR-koodin.</p>
        </form>
        <p>
          <Link to="/host" className="btn ghost">
            Pelinjohtajan kirjautuminen
          </Link>
        </p>
      </main>
    </>
  );
}
